import {QuestionOptions} from '../constants/question-options';
import {ObjectUtil} from '../util/object-util';

export class ProposalCheckboxFilter {
  selectedRole: string = null;
  noCoverage: boolean = false;
  leadInsurerNeeded: boolean = false;
  followingInsurerNeeded: boolean = false;
  limitPrice: boolean = false;
  minimumAmountInsured: number = 0;
  maximumAmountInsured: number = 1e12;

  includeOwn = false;

  lineOfBusiness = {};

  constructor(object?: Partial<ProposalCheckboxFilter>) {
    for (let lob of QuestionOptions.lineOfBusiness) {
      this.lineOfBusiness[lob] = false;
    }
    if (object) {
      ObjectUtil.assign(this, object);
    }
  }

}
